import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const PermissionKey_ExpressionView = 'permission-key--expression-view';
export const PermissionKey_ExpressionEdit = 'permission-key--expression-edit';
export const PermissionKey_ExpressionDelete = 'permission-key--expression-delete';
export const ExpressionPermissionKeys = {
    view: PermissionKey_ExpressionView,
    edit: PermissionKey_ExpressionEdit,
    delete: PermissionKey_ExpressionDelete,
};
export const DomainNamespace_Expression = 'Expression';
export const DomainNamespace_ExpressionEditor = 'Expression Editor';
export const ExpressionEditorPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_ExpressionEditor, defaultUIAccessLevels);
//# sourceMappingURL=permissions.js.map